/**
 * Tên thương hiệu từ hostname (login header).
 * fatie.agency → FATIE + AGENCY
 * social.fatie.agency → SOCIAL + FATIE AGENCY
 * localhost → LOCALHOST + PORTAL
 */
export function parseLoginBrand(hostname) {
  const host = String(hostname || "")
    .toLowerCase()
    .split(":")[0];

  if (!host || host === "localhost" || host === "127.0.0.1") {
    return { bold: "LOCALHOST", normal: "PORTAL" };
  }

  const parts = host.split(".").filter(Boolean);

  if (parts.includes("sotax")) {
    const rest = parts.filter((p) => p !== "sotax");
    return {
      bold: "SOTA-X",
      normal: rest.length
        ? rest.map((p) => p.toUpperCase()).join(" ")
        : "",
    };
  }
  if (parts.length >= 3) {
    return {
      bold: parts[0].toUpperCase(),
      normal: parts
        .slice(1)
        .map((p) => p.toUpperCase())
        .join(" "),
    };
  }
  if (parts.length === 2) {
    return {
      bold: parts[0].toUpperCase(),
      normal: parts[1].toUpperCase(),
    };
  }
  return { bold: host.toUpperCase(), normal: "PORTAL" };
}

/**
 * Từ name branch-config (vd. "FATI ENTERPRISE AGENCY") hoặc API brand_*.
 * - mode = "hub" (không có thông tin chi nhánh) → fallback "AGENCY PORTAL".
 */
export function parseAgencyBranchBrand(data) {
  if (!data || typeof data !== "object") {
    return { bold: "AGENCY", normal: "PORTAL" };
  }
  if (data.mode === "hub") {
    return { bold: "AGENCY", normal: "PORTAL" };
  }
  if (data.brand_title_bold && data.brand_title_light) {
    return {
      bold: String(data.brand_title_bold),
      normal: String(data.brand_title_light),
    };
  }
  const name = String(data.name || "").trim();
  if (!name) {
    return { bold: "AGENCY", normal: "PORTAL" };
  }
  const match = name.match(/^(.+?)\s+AGENCY\s*$/i);
  if (match) {
    return { bold: match[1].trim().toUpperCase(), normal: "AGENCY" };
  }
  return { bold: name.toUpperCase(), normal: "AGENCY" };
}
